import React from 'react';
import ModuleBase from '../../components/ModuleBase/ModuleBase';
import styles from './style.module.scss';
import { Avatar, Typography, Space } from '@douyinfe/semi-ui';
import { IconLikeThumb } from '@douyinfe/semi-icons';

const { Text } = Typography;

const GroupInfo = ({ data, onEdit }) => {
    const { title, description, titleStyle = {}, descriptionStyle = {}, style = {} } = data || {};
    return (
        <ModuleBase onEdit={onEdit} style={style}>
            <div className={styles.groupInfo}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                    <Avatar
                        size={data?.avatarSize || "large"}
                        src={data?.avatar}
                        style={{ flexShrink: 0, borderRadius: data?.avatarBorderRadius || '' }}
                    >
                        {data?.title?.[0] || '?'}
                    </Avatar>
                    <div style={{ flex: 1, minWidth: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <Text strong style={{
                                display: 'block',
                                marginBottom: '12px',
                                fontSize: titleStyle.fontSize || '16px',
                                color: titleStyle.color || '#1C1F23',
                                backgroundColor: titleStyle.backgroundColor || '',
                                textAlign: titleStyle.textAlign || 'left'
                            }}>
                                {title}
                            </Text>
                            <Text type="secondary" style={{
                                fontSize: descriptionStyle.fontSize || '14px',
                                color: descriptionStyle.color || '#666666',
                                backgroundColor: descriptionStyle.backgroundColor || '',
                                lineHeight: descriptionStyle.lineHeight || 0,
                                display: 'block',
                                whiteSpace: 'pre-wrap'
                            }}>
                                {description}
                            </Text>
                        </div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            flexShrink: 0,
                        }}>
                            <IconLikeThumb style={{
                                color: data?.likeIconColor || '#666666',
                                fontSize: data?.likeIconSize || 16,

                            }} />
                            <Text type="tertiary" style={{
                                color: data?.likeIconColor || '#666666',
                                fontSize: data?.likeIconSize || 16,
                            }}>{data?.likes || 0}</Text>
                        </div>
                    </div>
                </div>
            </div>
        </ModuleBase>
    );
};

export default GroupInfo;